import type {Supplier} from "../types/Supplier";

/**
 * Extracts a lat/lng pair from a Supplier's address coordinates.
 * @returns The parsed coordinates, or null if either value is not a valid number.
 */
export const getLatLng = (supplier: Supplier): { lat: number; lng: number } | null => {
  const lat = parseFloat(supplier.addressLatitude);
  const lng = parseFloat(supplier.addressLongitude);
  if (isNaN(lat) || isNaN(lng)) return null;
  return { lat, lng };
};

